<template>
  <div class="sorter-container">
    <f7-link popover-open=".popover-sort">
      <img
        src="@/static/icons/ic_order.svg"
        class="padding-right-half"
      >
      <template v-if="sortFieldSelected">
        {{ sortFieldSelected.Name }}
      </template>
    </f7-link>
    <div v-if="!disabled">
      <f7-popover
        class="popover-sort"
        :opened="popoverSortIsOpened"
        @popover:closed="popoverSortIsOpened = false"
      >
        <f7-list>
          <f7-list-item
            v-for="filterElement in sortFieldList"
            :key="filterElement.Name"
            link="#"
            popover-close
            chevron
            @click="ChangeSortElement(filterElement)"
          >
            {{ filterElement.Name }}
          </f7-list-item>
        </f7-list>
      </f7-popover>
    </div>
    <img
      src="@/static/icons/ic_arrow_down.svg"
      class="padding-left"
    >
  </div>
</template>

<script>
export default {
  name: 'UCSortPopover',
  props: {
    sortFieldList: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },

  emits: ['on-change'],

  data() {
    return {
      sortFieldSelected: null,
      popoverSortIsOpened: false,
    };
  },
  watch: {
    sortFieldList(val) {
      if (val != null && val.length > 0) {
        [this.sortFieldSelected] = val;
      }
    },
  },

  methods: {
    ChangeSortElement(val) {
      this.sortFieldSelected = val;
      this.$emit('on-change', val);
    },
  },
};
</script>

<style lang="scss">
.sorter-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--his-steel-blue);
  color: #fff;
  height: 24px;
  padding: 0 10px;
  border-radius: 3px;
  margin-right: 8px;
  font-size: 10px;

  a {
    color: #fff;
  }
}
</style>
